
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"fill":"#224DBA","width":"28","height":"20","rx":"2"}}),_c('path',{attrs:{"d":"M9.54 13.34H7.9l-1.231-4.8c-.059-.222-.183-.417-.365-.509A5.26 5.26 0 004.8 7.523v-.185h2.643c.365 0 .639.278.684.6l.639 3.463 1.64-4.063H12L9.54 13.34zm3.373 0h-1.55l1.276-6.002h1.55l-1.276 6.001zM16.193 9c.046-.322.32-.507.639-.507a2.832 2.832 0 011.504.277l.274-1.292a3.847 3.847 0 00-1.413-.278c-1.504 0-2.599.831-2.599 1.985 0 .877.776 1.338 1.323 1.616.592.277.82.461.774.738 0 .415-.456.6-.911.6a3.836 3.836 0 01-1.595-.37l-.274 1.293c.547.23 1.14.324 1.687.324 1.686.045 2.734-.785 2.734-2.032 0-1.57-2.142-1.661-2.142-2.353zm7.566 4.34l-1.23-6.002h-1.322a.687.687 0 00-.638.462l-2.279 5.54h1.596l.318-.878h1.96l.182.877h1.413zm-2.324-4.386l.455 2.262h-1.276l.821-2.262z","fill":"#FFF"}})])])
          )
        }
      }
    